import React from 'react';
import {Flex, Typography} from 'antd';
import StorageItem from './StorageItem';
import {useMergeBlockImageMap, resolveMergeBlockImageUrl} from "../../hooks/useMergeBlockImageMap";

const ItemStorage = React.memo(({storageItems, currentStorageSize, mergeMainData}) => {
    const {data: imageMap} = useMergeBlockImageMap();
    const totalSlots = currentStorageSize;
    const renderedItems = [];

    // 실제 아이템을 먼저 추가
    storageItems.forEach(item => {
        renderedItems.push(item);
    });

    // 부족한 슬롯을 빈 슬롯으로 채움
    // 사진을 보면 스토리지에는 항상 최대 슬롯 개수만큼 표시되어야 합니다.
    // 따라서, `currentStorageSize`를 기준으로 빈 슬롯을 채웁니다.
    for (let i = renderedItems.length; i < totalSlots; i++) {
        renderedItems.push(null);
    }

    return (
        <div
            style={{
                width: 'min(90vw, 500px)', // 머지판과 동일한 최대 너비 유지
                marginTop: '20px',
                padding: '15px 10px',
                backgroundColor: '#fff',
                borderRadius: '20px',
                boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
                border: '2px solid #a0a0a0',
                position: 'relative',
                boxSizing: 'border-box',
                display: 'flex', // 내부 콘텐츠를 Flex로 배치
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            <Flex
                wrap="wrap"
                justify="flex-start"
                align="flex-start" // 아이템이 위쪽부터 정렬되도록
                gap="5px" // 각 StorageItem의 calc(25% - 5px)와 일치시킵니다.
                style={{
                    maxHeight: '300px',
                    overflowY: 'auto',
                    paddingRight: '5px',
                    width: '100%', // 내부 Flex 컨테이너가 부모의 100%를 차지하도록
                    boxSizing: 'border-box',
                }}
            >
                {renderedItems.map((item, index) => (
                    // `item`이 null이면 `empty-${index}`를 key로 사용
                    // `item.slotIndex`는 -1이므로, blockIndex와 일반 index를 조합하여 고유한 key 생성
                    <StorageItem key={item ? `storage-${item?.blockIndex || 'empty'}-${index}` : `empty-storage-${index}`}
                                 item={item} itemImage={resolveMergeBlockImageUrl(mergeMainData[item?.blockIndex]?.resourcePath, imageMap)}/>
                ))}
            </Flex>
        </div>
    );
});

export default ItemStorage;